import { withShadowDOM } from '../../hoc';
import { TextInput as Component } from './component';
export const TextInput = withShadowDOM(Component, { zIndex: 'auto' });
